import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import BannerManagerService from "../../../services/home/BannerManager";
import config from "../../../config";
import { useNavigate } from "react-router-dom";


export default function StaggeredBookBanner() {
  const [bookBanners, setBookBanners] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await BannerManagerService.getAllBanners();
        const filtered = res.filter(
          (b) =>
            b.platform === "WEB" &&
            b.bannerType === "BOOK" &&
            b.position === "MIDDLE"
        );
        setBookBanners(filtered.slice(0, 3));
      } catch (error) {
        console.error("Failed to fetch book banners", error);
      }
    };

    fetchBanners();
  }, []);

  if (bookBanners.length < 3) return null;

  return (
    <section className="max-w-screen-xl mx-auto px-4 py-10">
      <div className="flex flex-col md:grid md:grid-cols-2 gap-6">
        {/* Left large banner */}
        <motion.div
           onClick={() => navigate(bookBanners[0].bannerCtaBtnLink || `/book/${bookBanners[0].bookId}`)}
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          className="cursor-pointer relative w-full h-[240px] sm:h-[260px] md:h-full md:min-h-[420px] overflow-hidden rounded-2xl shadow-lg group"
        >
          <img
            src={`${config.url}/bannerImage/${bookBanners[0].bannerImage}`}
            alt={bookBanners[0].bannerHeading || "Book banner"}
            className="w-full h-full object-fit group-hover:scale-105 transition-transform duration-500"
          />
          {(bookBanners[0].bannerHeading || bookBanners[0].bannerHighlight) && (
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent text-white flex flex-col justify-end p-6 backdrop-blur-sm">
              <h3 className="text-lg sm:text-xl md:text-2xl font-semibold mb-1">
                {bookBanners[0].bannerHeading}
              </h3>
              <p className="text-sm text-white/90">
                {bookBanners[0].bannerHighlight}
              </p>
            </div>
          )}
        </motion.div>

        {/* Right stacked banners */}
        <div className="flex flex-col gap-6">
          {bookBanners.slice(1).map((banner, idx) => (
            <motion.div
              key={banner.bannerId}
              onClick={() => navigate(banner.bannerCtaBtnLink || `/book/${banner.bookId}`)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: idx * 0.2 }}
              className="cursor-pointer relative h-[140px] sm:h-[160px] md:h-[50%] w-full overflow-hidden rounded-2xl shadow-lg group"
            >
              <img
                src={`${config.url}/bannerImage/${banner.bannerImage}`}
                alt={banner.bannerHeading || "Book banner"}
                className="w-full h-full object-fit group-hover:scale-105 transition-transform duration-500"
              />
              {(banner.bannerHeading || banner.bannerHighlight) && (
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent text-white flex flex-col justify-end p-6 backdrop-blur-sm">
                  <h3 className="text-lg sm:text-xl md:text-2xl font-semibold mb-1">
                    {banner.bannerHeading}
                  </h3>
                  <p className="text-sm text-white/90">
                    {banner.bannerHighlight}
                  </p>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
